/* Shared camera translation. Model geometry, scale, orbit and zoom are untouched. */
(() => {
  if (window.inspireViewerPan) return;
  window.inspireViewerPan = true;
  const style = document.createElement('style');
  style.textContent = '.viewer-pan{font:inherit;margin:8px 0 12px;padding:0 12px}.viewer-pan summary{cursor:pointer;text-align:center}.viewer-pan label{display:grid;grid-template-columns:75px minmax(0,1fr);align-items:center;gap:10px;margin:10px 0}.viewer-pan input{width:100%;min-width:0;accent-color:#111}.viewer-pan button{display:block;margin:10px auto;background:white;color:inherit;border:1px solid #aaa;padding:6px 12px;font:inherit;cursor:pointer}.viewer-pan :focus-visible{outline:2px solid currentColor;outline-offset:3px}';
  document.head.append(style);
  function controls(parent, resource, move, center) {
    const panel = document.createElement('details');
    panel.className = 'viewer-pan';
    panel.dataset.ihFeature = 'viewer_pan';
    panel.dataset.ihResource = resource;
    panel.innerHTML = '<summary>Move view</summary><label>Horizontal<input type="range" min="-100" max="100" value="0" step="1" aria-label="Move view horizontally"></label><label>Vertical<input type="range" min="-100" max="100" value="0" step="1" aria-label="Move view vertically"></label><button type="button">Center view</button>';
    const inputs = [...panel.querySelectorAll('input')];
    let last = [0, 0];
    const clear = () => { last = [0, 0]; inputs.forEach(i => { i.value = '0'; }); };
    inputs.forEach((input, axis) => {
      input.addEventListener('input', () => {
        const value = Number(input.value);
        move(axis, (value - last[axis]) / 100);
        last[axis] = value;
      });
      input.addEventListener('change', () => window.InspireEngagement?.track('viewer_pan', axis ? 'vertical' : 'horizontal', resource));
    });
    panel.querySelector('button').addEventListener('click', () => {
      center(); clear();
      window.InspireEngagement?.track('viewer_pan', 'center', resource);
    });
    parent.append(panel);
    document.dispatchEvent(new CustomEvent('product-info:loaded'));
    return clear;
  }
  function solo(viewer) {
    if (viewer.dataset.panReady || !viewer.loaded) return;
    viewer.dataset.panReady = 'true';
    // Existing text explains rotation; avoid the built-in camera wiggle while panning.
    viewer.interactionPrompt = 'none';
    let origin, extent;
    const setTarget = p => {
      const o = viewer.getCameraOrbit();
      viewer.cameraTarget = `${p.x}m ${p.y}m ${p.z}m`;
      viewer.cameraOrbit = `${o.theta}rad ${o.phi}rad ${o.radius}m`;
      viewer.jumpCameraToGoal();
    };
    const clear = controls(viewer.parentElement, 'product', (axis, delta) => {
      const o = viewer.getCameraOrbit(), p = viewer.getCameraTarget();
      const t = o.theta, f = o.phi;
      const v = axis ? [-Math.sin(t)*Math.cos(f), Math.sin(f), -Math.cos(t)*Math.cos(f)] : [Math.cos(t), 0, -Math.sin(t)];
      // Translate camera and target together so the object moves with the slider.
      setTarget({ x:p.x-v[0]*delta*extent, y:p.y-v[1]*delta*extent, z:p.z-v[2]*delta*extent });
    }, () => setTarget(origin));
    function reset() {
      origin = viewer.getCameraTarget();
      const d = viewer.getDimensions();
      extent = Math.max(d.x, d.y, d.z) * .65;
      clear();
    }
    reset();
    viewer.addEventListener('load', reset);
  }
  function hand(element) {
    const scene = element.handScene;
    if (element.dataset.panReady || !scene?.hardware || !scene.framingCenter) return;
    element.dataset.panReady = 'true';
    const translate = delta => {
      scene.camera.position.add(delta); scene.orbit.target.add(delta);
      scene.orbit.update(); scene.render();
    };
    const clear = controls(element.querySelector('.variant-model__comparison-body'), 'hand', (axis, delta) => {
      scene.camera.updateMatrixWorld();
      const size = scene.framingSize;
      const v = scene.camera.position.clone().setFromMatrixColumn(scene.camera.matrixWorld, axis);
      translate(v.multiplyScalar(-delta * Math.max(size.x, size.y, size.z) * .65));
    }, () => translate(scene.framingCenter.clone().sub(scene.orbit.target)));
    const fit = scene.fitCameraToScene;
    scene.fitCameraToScene = function (...args) { const result = fit.apply(this, args); clear(); return result; };
  }
  let pending;
  function scan() {
    clearTimeout(pending);
    pending = setTimeout(() => {
      document.querySelectorAll('.variant-model__viewer').forEach(solo);
      document.querySelectorAll('[data-hand-comparison]').forEach(hand);
    }, 80);
  }
  document.addEventListener('load', scan, true);
  document.addEventListener('product-info:loaded', scan);
  new MutationObserver(scan).observe(document.body, { childList:true, subtree:true, attributes:true, attributeFilter:['data-scale-validation'] });
  scan();
})();
